export default import(/* webpackChunkName: "callback-request" */ "./CallbackRequest");



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/CallbackRequest/async.ts